export default "__VITE_ASSET__rnkIB31i__"